import { render, staticRenderFns } from "./UniversityNewsModal.vue?vue&type=template&id=52eb5aaa&"
import script from "./UniversityNewsModal.vue?vue&type=script&lang=js&"
export * from "./UniversityNewsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports